// extracted by mini-css-extract-plugin
export var searchHeader = "_26-0";
export var searchHeaderDark = "_26-1";